import { useLocalStorage } from './useLocalStorage';

const CONFIGS_KEY   = 'extractor:configs';
const LAST_CFG_KEY  = 'extractor:lastConfig';

/**
 * Gère un ensemble de configurations nommées persistées dans le localStorage.
 *
 * Chaque configuration est un objet :
 *   { name, savedAt, localisation, typeLoc, csvSeparator, listSeparator,
 *     geoMode, columnVisibilityModel, columnOrder? }
 */
export function useConfigManager() {
    const [configs, setConfigs]           = useLocalStorage(CONFIGS_KEY,  {});
    const [lastConfigName, setLastConfigName] = useLocalStorage(LAST_CFG_KEY, null);

    /** Sauvegarde (ou écrase) une configuration par son nom. */
    const saveConfig = (name, data) => {
        const entry = { ...data, name, savedAt: new Date().toISOString() };
        setConfigs(prev => ({ ...prev, [name]: entry }));
        setLastConfigName(name);
        return entry;
    };

    /** Supprime une configuration. */
    const deleteConfig = (name) => {
        setConfigs(prev => { const n = { ...prev }; delete n[name]; return n; });
    };

    /** Retourne une configuration par son nom, ou null. */
    const getConfig = (name) => configs[name] ?? null;

    /** Liste triée du plus récent au plus ancien. */
    const configList = Object.values(configs)
        .sort((a, b) => new Date(b.savedAt) - new Date(a.savedAt));

    return { configList, lastConfigName, setLastConfigName, saveConfig, deleteConfig, getConfig };
}

